import React, { memo } from 'react';

/**
 * Full-screen centered spinner for initial load state.
 */
const LoadingSpinner = memo(() => (
  <div className="flex items-center justify-center min-h-[60vh]">
    <div className="w-10 h-10 border-4 border-slate-200 border-t-slate-600 rounded-full animate-spin" />
  </div>
));

LoadingSpinner.displayName = 'LoadingSpinner';

export default LoadingSpinner;
